import Swiper from "swiper";

export default class CaseHome {

    static get selector() {
      return '.caseHome';
    }
    
    constructor(el) {
        this.el = el;
        this.slider = this.el.querySelector('.caseHome__slider');

        let slider = new Swiper(this.slider, {

            slidesPerView: 1,
            spaceBetween: 8,

            breakpoints: {
                // when window width is >= 600px
                600: {
                  slidesPerView: 2,
                  spaceBetween: 8
                },

                1024: {
                    slidesPerView: 3,
                    spaceBetween: 24
                  },

            }
        });
    }

    
}
